document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    function initializeCardExpansion() {
        $('.pageBlock--card__perex').off('click.cardExpansion').on('click.cardExpansion', 'button', function() {
            $(this).closest('.pageBlock--card__perex').addClass('is-expanded');
        });
    }

    initializeCardExpansion();
});
